import React from "react"
import classNames from "classnames"
import { Radio as AntdRadio } from "antd"

import styles from "./Radio.module.css"

export const Radio = ({ className, ...rest }) => <AntdRadio className={classNames(className, styles.radio)} {...rest} />
